/**
 * Turkish money format: thousands with dot, decimals with comma (e.g. 26.123,58 TL)
 * Converts Shopify US-style output (9,597.00) to Turkish format (9.597,00).
 */
(function () {
  // Match US-style price: digits+commas, dot, exactly 2 decimals (no digit after), optional currency
  const PRICE_REGEX = /([\d,]+)\.(\d{2})(?!\d)\s*(TL|₺|TRY)?/g;

  function formatPriceToTurkish(text) {
    if (!text || typeof text !== 'string') return text;
    return text.replace(PRICE_REGEX, function (_, intPart, decPart, currency) {
      if (intPart.indexOf('.') !== -1) return _;
      const digitsOnly = intPart.replace(/\D/g, '');
      const withDots = digitsOnly.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      const suffix = currency ? ' ' + currency : '';
      return withDots + ',' + decPart + suffix;
    });
  }

  function formatElement(el) {
    if (!el || el.dataset.moneyFormattedTr === 'true') return;
    if (el.childNodes.length === 1 && el.childNodes[0].nodeType === Node.TEXT_NODE) {
      const text = el.childNodes[0].textContent;
      const formatted = formatPriceToTurkish(text);
      if (formatted !== text) {
        el.childNodes[0].textContent = formatted;
        el.dataset.moneyFormattedTr = 'true';
      }
      return;
    }
    // Element with mixed content: format only direct text nodes that look like money
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
    let node;
    while ((node = walker.nextNode())) {
      const formatted = formatPriceToTurkish(node.textContent);
      if (formatted !== node.textContent) {
        node.textContent = formatted;
      }
    }
    el.dataset.moneyFormattedTr = 'true';
  }

  const PRICE_SELECTORS = [
    '.price-item',
    '.price .price__regular .price-item--regular',
    '.price .price__sale .price-item--sale',
    '.price .price__compare .price-item',
    '.totals__subtotal-value',
    '.cart-item__price',
    '.cart-item__price .price-item',
    '.order-table__value',
    '.discount-amount',
    '[data-format-money-tr]',
    '.unit-price .price',
    '.header__cart-pill-total'
  ].join(',');

  function runFormat() {
    document.querySelectorAll(PRICE_SELECTORS).forEach(formatElement);
    // Also format any .price container that has not been marked (nested price-item already done)
    document.querySelectorAll('.price:not([data-money-formatted-tr])').forEach(function (priceEl) {
      if (priceEl.querySelector('.price-item')) return; // already handled via .price-item
      formatElement(priceEl);
    });
  }

  function observeAndFormat(root) {
    if (!root) return;
    runFormat();
    var obs = new MutationObserver(function () {
      runFormat();
    });
    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      runFormat();
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) observeAndFormat(cartDrawer);
      var mainCart = document.getElementById('main-cart-items') || document.querySelector('.main-cart-items');
      if (mainCart) observeAndFormat(mainCart);
      var headerCart = document.querySelector('.header__cart');
      if (headerCart) observeAndFormat(headerCart);
    });
  } else {
    runFormat();
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) observeAndFormat(cartDrawer);
    var mainCart = document.getElementById('main-cart-items') || document.querySelector('.main-cart-items');
    if (mainCart) observeAndFormat(mainCart);
    var headerCart = document.querySelector('.header__cart');
    if (headerCart) observeAndFormat(headerCart);
  }

  window.formatMoneyTr = runFormat;
})();
